import { ADDED_TO_CART_EVENT, ADD_TO_CART_EVENT_DATA, CartData, processCartData } from '.';
import { pushEventToGTMDataLayer } from '../gtm-data-layer';
import { heapTrack } from '../helpers';
import { isEligibleForPreorder } from 'src/scripts/templates/product/utils';

// ? [REVISIT] mapping variant info --> product info is closer to
// `addedVariantIds.map(variantId => cartData.regularItems.find(cartItem => cartItem.id.toString() === variantId))`
// ? in order for this to work we need to fire `await resyncCart()` before `dispatchAddedToCartEvent`
/*
ex:
        await reSyncCart(newCartData);
        dispatchAddedToCartEvent([variantId], ATBtype, newCartData);
*/
const prepDataForDataLayer = (addedVariantIds: string[], cartData: CartData) => {
  const newlyCartedItems = cartData.regularItems
    .filter((item) => addedVariantIds.includes(item.id.toString()))
    .map((cartItem) => {
      const newProductObject = {
        product_title: cartItem.product_title,
        final_price: cartItem.final_price,
        sku: cartItem.sku,
        variant_id: cartItem.variant_id,
        color: '',
        size: '',
        product_id: cartItem.product_id,
        tags: cartItem.tags,
      };
      cartItem.options_with_values.forEach((option) => {
        newProductObject[option.name.toLowerCase() as 'size' | 'color'] = option.value;
      });
      return newProductObject;
    });
  return newlyCartedItems;
};

export const initializeCartAnalytics = () => {
  //@ts-expect-error
  window.cartAnalyticsHasOnboardATBTracking = true;
  document.addEventListener(ADDED_TO_CART_EVENT, async (event) => {
    const addToCartEvent = event as CustomEvent<ADD_TO_CART_EVENT_DATA>;
    const { newCartData } = addToCartEvent.detail;
    const processedCartData = processCartData(newCartData);
    const cartedItemsArray = prepDataForDataLayer(addToCartEvent.detail.variantIds, processedCartData);
    pushEventToGTMDataLayer({
      event: 'alo_addToCart',
      cartedItemsArray,
    }); // ? [REVISIT] Move all 'alo_addToCart' dependent tags here from GTM???

    cartedItemsArray?.forEach((item) => {
      const filterItem = processedCartData.regularItems.find((regularItem) => regularItem.id === item.variant_id);
      const itemQuantityAvailable = filterItem?.quantityAvailable ?? 0;
      const estimatedShipStartDate = filterItem?.estimatedShipStartDate;
      const tags = item.tags ?? [];
      const isPreorder = isEligibleForPreorder(itemQuantityAvailable, tags, estimatedShipStartDate);

      heapTrack('Add To Bag', {
        product_name: item.product_title,
        price: item.final_price / 100,
        sku: item.sku,
        size: item.size || 'no size reported',
        color: item.color || 'no color reported',
        ATBtype: addToCartEvent.detail.ATBtype,
        product_id: item.product_id,
        is_preorder: isPreorder,
      });
    });
  });
};
